/*
 * matrix-rain.js — green "digital rain" + a typed Y2K boot message.
 * Self-hosted, no dependencies. Used by sections/y2k.liquid on the Y2K
 * product/collection templates.
 *
 * Optional config (set before this script):
 *   window.Y2K_LINES — array of strings typed in the boot overlay, then faded.
 */
(function () {
  "use strict";

  var reduce =
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  // ---- digital rain --------------------------------------------------
  var canvas = document.createElement("canvas");
  canvas.id = "matrix-rain";
  // Reparent to <body> so fixed positioning escapes any section stacking
  // context and the canvas truly fills the viewport behind the content.
  (document.body || document.documentElement).appendChild(canvas);

  var ctx = canvas.getContext("2d");
  var CHARS =
    "ｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎ0123456789ABCDEFｦﾝ$+*=<>".split("");
  var FONT = 16;
  var cols, drops;

  function resize() {
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    cols = Math.ceil(canvas.width / FONT);
    drops = [];
    for (var i = 0; i < cols; i++) {
      drops[i] = Math.floor((Math.random() * canvas.height) / FONT);
    }
  }
  resize();
  window.addEventListener("resize", resize);

  function frame() {
    // translucent black wash leaves fading trails
    ctx.fillStyle = "rgba(0, 0, 0, 0.06)";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.font = FONT + "px monospace";
    for (var i = 0; i < cols; i++) {
      var ch = CHARS[Math.floor(Math.random() * CHARS.length)];
      var x = i * FONT;
      var y = drops[i] * FONT;
      // leading glyph brighter than the trail
      ctx.fillStyle = Math.random() < 0.04 ? "#caffca" : "#00ff66";
      ctx.fillText(ch, x, y);
      if (y > canvas.height && Math.random() > 0.975) drops[i] = 0;
      drops[i]++;
    }
  }

  if (reduce) {
    // Static-ish: paint a couple of frames so there's atmosphere without motion.
    frame(); frame();
  } else {
    setInterval(frame, 55);
  }

  // ---- typed Y2K boot message ---------------------------------------
  var lines = window.Y2K_LINES;
  if (lines && lines.length) {
    var box = document.createElement("div");
    box.id = "y2k-message";
    document.body.appendChild(box);

    var li = 0;
    function typeLine() {
      if (li >= lines.length) {
        setTimeout(function () { box.classList.add("y2k-fade"); }, 2600);
        return;
      }
      var row = document.createElement("div");
      box.appendChild(row);
      var text = lines[li++], c = 0;
      if (reduce) { row.textContent = text; typeLine(); return; }
      var iv = setInterval(function () {
        row.textContent = text.slice(0, ++c);
        if (c >= text.length) { clearInterval(iv); setTimeout(typeLine, 380); }
      }, 35);
    }
    typeLine();
  }
})();
